import clsx from 'clsx';

import Typography from '../../../components/Typography';
import { activityTileClasses, IconWrapper, Root } from './styles';
import { TileProps } from './types';

const Tile = ({
  icon: Icon,
  hoverIcon: HoverIcon,
  title,
  color = 'primary',
  iconSize = 36,
  onClick,
  isActive,
}: TileProps) => {
  return (
    <Root
      color={color}
      disableRipple
      onClick={onClick}
      className={clsx(activityTileClasses.root, { [activityTileClasses.active]: isActive })}
    >
      <IconWrapper>
        <Icon size={iconSize} className={activityTileClasses.icon} />
        <HoverIcon size={iconSize} className={activityTileClasses.hoverIcon} />
      </IconWrapper>
      <Typography variant="h6Bold" component="div" color="inherit" whiteSpace="nowrap">
        {title}
      </Typography>
    </Root>
  );
};

export default Tile;
